export default "__VITE_ASSET__DkaEIm_2__"